import React from "react"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Flex from "@irati/ui/src/Flex"
import recogniseSuccess from "../../../images/recognise-success.gif"
import {Image} from "./styled"

interface Props extends InjectIntlProps {}
const NewRecognitionDetails: React.FC<Props> = (props) => {
  const {formatMessage} = props
  return (
    <Flex direction="column" justifyContent="center" alignItems="center" height="100%">
      <Image alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})} src={recogniseSuccess} />
      <H2 textAlign="center">
        <FormattedMessage id="recognition.popup.createRecognitionManager.success.headerImage" />
      </H2>
    </Flex>
  )
}

export default injectIntl(NewRecognitionDetails)
